import { parse } from 'hub-http/helpers/params';
export const getLocationQuery = location => {
  return location && location.search ? parse(location.search.substr(1)) : {};
};